import { OpenAPIRegistry, extendZodWithOpenApi } from '@asteasolutions/zod-to-openapi'
import { z } from 'zod'

extendZodWithOpenApi(z)

/**
 * Single registry used by every schema module to register paths and components.
 * The OpenAPI generation script reads from this.
 */
export const registry = new OpenAPIRegistry()
